import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CHOOSE_FONT = 'choose-font'
export const APPLY = 'apply'

export default {
  [PORTUGUESE]: {
    [CHOOSE_FONT]: 'Escolha a fonte da nuvem de palavras',
    [APPLY]: 'Aplicar',
  },

  [ENGLISH]: {
    [CHOOSE_FONT]: 'Choose the word cloud font',
    [APPLY]: 'Apply',
  },

  [SPANISH]: {
    [CHOOSE_FONT]: 'Elija la fuente de la nube de palabras',
    [APPLY]: 'Aplicar',
  },
}
